module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/box.jpg"
    }
  })])]), _vm._v(" "), _c('td', [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("Introduction")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticStyle: {
      "color": "#585858"
    }
  }, [_vm._v("I")])]), _vm._v("N "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("FINDING THE FEW")]), _vm._v(" (Grub Street 2009) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Finding The Fo")]), _vm._v("e (Grub Street 2010), I was able to tell the story of a number of RAF and Luftwaffe fliers lost over the UK during the Battle of Britain and later. Those two books, and the stories contained within them, proved to be exceptionally popular and there was an immediate clamour for more stories of the same genre. However, all of the missing aircrew losses for the 1940 period had been pretty much exhausted within those two books and thus it was only natural to look much further afield both in terms of timeframes and geographical location. Indeed, this book looks at cases from the First World War through to the second, into the Korean War to the Vietnam War and right up to the Gulf War. It is a fact that whenever and wherever aircrews fly off to do combat there will always be a percentage of those who will not return. Of those, there is yet a further percentage of fliers who have simply disappeared and this book looks at a range of such cases across a time span of almost ninety years. Some have been resolved satisfactorily. Others remain on the ‘pending’ list. Other cases yet will probably always remain a mystery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In terms of the numbers of those aviators who are missing and unaccounted for from all nations and all conflicts it is impossible to put a figure, but if we take RAF and Commonwealth aircrew missing over north-west Europe alone we have a figure currently standing in the region of 20,300 names. Added to those, the losses of American air forces over north-west Europe who are still unaccounted for stands at a total of 5,126 whilst the Flying Services Memorial at Arras records the names of around a further 1,000 casualties of the First World War from the RFC and RNAS. In total, therefore, we have here around 26,500 allied fliers lost and missing in the European theatre alone during both wars – and this does not include an almost incalculable and unknown number of those from the Luftwaffe or Imperial German Air Service or Italian air forces, for example. Neither does it include, of course, the losses of all other air forces on a global basis. Quite simply, the numbers are staggering and it is hardly surprising that from amongst that huge number there continues to be ongoing finds of missing aircrew around the world that have been subject to discovery and identification, either by accident or intent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the very outset of aerial warfare there have been efforts to trace and identify the missing, and those efforts began with the work of the Imperial War Graves Commission and the Directorate of War Graves Registration and Enquiries in the immediate aftermath of the "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("First World War. Indeed, our book logically begins with the very prominent case of Major Edward ‘Mick’ Mannock VC DSO MC whom I suggest lies in a grave marked to an unidentified aviator. It is worth considering, too, another case involving fliers from that conflict who were subsequently identified and given named graves in what must have been one of the very first post-conflict recoveries of missing fliers found in the wreckage of their shot-down aircraft.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/page10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This incredible photograph shows a Typhoon aircraft rudder pedal that was found washed up on the foreshore at East Preston, near Littlehampton, West Sussex, just after the war. The story it tells is a chilling and yet an unknown one. Who was the unfortunate pilot of this Typhoon? Was he dragged to his death as the aircraft slid beneath the waves? Or did he struggle free, leaving just his boot behind in the cockpit? If he didn’t survive the crash, then did the sea ever deliver up his body? If not, he must be one of just over 20,000 RAF and Commonwealth airmen with no known graves who were killed on active service over northwest Europe and who are commemorated by name on the Runnymede Memorial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1927 the Imperial War Graves Commission (now Commonwealth War Graves Commission) unexpectedly wrote to the family of Lt E H N Stroud of the Royal Flying Corps with astonishing news that their long-lost relative had been found. It stated:")])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "bquotnoindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“In the course of the work of removing the bodies of soldiers who were buried in isolated and scattered graves to cemeteries where their graves could be cared for and ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("maintained, the remains of two officers were found in the debris of an aeroplane at a spot about one mile east of Zillebeke, which is south-east of Ypres, and in order to secure the reverent maintenance of the grave in perpetuity the remains were carefully and reverently reburied in Sanctuary Wood Cemetery, Zillebeke.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "bquotindent"
  }, [_vm._v("“A regimental button of the Royal Artillery and an aeroplane strut were recovered and are in this office and it has been ascertained from the markings on the strut that the machine was an R.E.8 type, and that the aeroplane in question was manufactured by the Coventry Ordnance Works during the period 15 March 1917 to 15 September 1918; also, the number of the machine was C.5037.")]), _vm._v(" "), _c('p', {
    staticClass: "bquotindent"
  }, [_vm._v("“From the investigations made it has been ascertained that Lieut Stroud and Captain C G White MC of the Royal Field Artillery, attached to 53 Squadron RAF, left the aerodrome at Clairmarais South flying an R.E.8 machine, No 5037, on counter-attack patrol duty, in the locality in which the bodies were found, but failed to return.")]), _vm._v(" "), _c('p', {
    staticClass: "bquotindent"
  }, [_vm._v("“A cross, with their names inscribed, has been erected at the head of the grave in Sanctuary Wood Cemetery.”")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Way before the advent of detailed scientific identification techniques then, we have here two lost fliers being named, and long after the event of their deaths, through basic detective work. This book charts a number of cases of missing airmen from the first and second world wars through to Vietnam, Korea and right up to the Gulf War. The passage of time has neither lessened the desire to bring home missing aviators nor has its importance diminished to those left behind. The detective trail can often be long and tortuous, but a satisfactory conclusion can mean just as much to relatives more than seventy years later as it did to those who have had to wait a considerably shorter while. We only have to look at the words of Richard Allen, brother of Fg Off Derek Allen (featured in ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _vm._v("), to appreciate that fact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In writing this book I hope also to have kept alive the memory of those aircrew who are lost and still missing. Recently, a Lt Col Fullwood of the 2nd Batt, 9th US Marine Corps, said at a memorial service for a fallen comrade:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bquotnoindent"
  }, [_vm._v("“A man dies first when his body expires, and second when his name is no longer spoken.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I hope this book will ensure that some of these men’s names continue to be spoken, although by its very nature it can only deal with just a very small number of individual cases. There are many more stories such as these that yet remain to be told and many more names to be kept alive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Andy Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("East Sussex, July 2011")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/page12.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Major ‘Mick’ Mannock, VC DSO MC, the highest scoring RAF fighter pilot of all time and who still remains officially listed as missing in action.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798567f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 75
// module chunks = 0